'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */
import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import Button from '../../Button';
import ArrowRightAlt from '../../icons/ArrowRightAlt';
import { pushDataLayer } from '../pushDataLayer';
import { ComponentBlueCta } from '$/(cms)/_modules/cmsService/types';
import { FeLink } from '$/components/FeLink';

export const BlueCTA: React.FC<ComponentBlueCta> = ({
  title,
  subtitle,
  url,
  button,
  image,
}) => {
  const handleCTA_click = () => {
    pushDataLayer({
      event: 'navigate',
      component_type: 'above-footer',
      component_title: 'Looking for other providers or plans_Compare All Plans',
      action: 'click',
    });
  };

  return (
    <div className="flex flex-row flex-wrap items-center justify-between rounded-radius/table border border-solid border-colors/neutral-gray-300 p-2 bg-blue-light md:p-3">
      {image?.url ? (
        <CmsImage
          unoptimized
          className="mr-2"
          width={64}
          height={64}
          alt={image.alternativeText ?? ''}
          src={image.url}
        />
      ) : null}

      <div className="flex-1 md:mr-5">
        <h3 className="md:mhg-alpha-typography-title-2 mhg-alpha-typography-bullet-1 text-fill/primary-dark">
          {title}
        </h3>
        <div className="mhg-alpha-typography-body-2 text-colors/neutral-gray-800">
          {subtitle}
        </div>
      </div>

      <Button
        className="mt-2 flex-[0_0_100%] md:mt-0 md:flex-[0_1_auto]"
        variant="filled"
        color="text-primary"
        onClick={() => handleCTA_click()}
        endIcon={<ArrowRightAlt />}
        size="small"
      >
        <FeLink href={url ?? ''}>{button}</FeLink>
      </Button>
    </div>
  );
};
